import React from 'react';

export function StepIdentificatorLabel() {
  return <>Identifikátor subjektu</>;
}
